import { Component, OnInit, ViewChild, HostListener, Input, AfterViewInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ResizeEvent } from "angular-resizable-element";
import { ToastrService } from "ngx-toastr";
import { ServiceRoleComponent } from "../../../components/pages/roles/components/service/service-role.component";
import { RolesComponent } from "../../../components/pages/roles/roles.component";
import { Message } from "../../../models/message";
import { MuleService } from "../../../models/mule-service";
import { Role } from "../../../models/role";
import { RoleRegistration } from "../../../models/role-registration";
import { RoleStatus } from "../../../models/role-status";
import { RoleStatusMessage } from "../../../models/status-message";
import { ClassificationType } from "../../../models/classification-type";
import { MuleControllerService } from "../../../services/mule-controller/mule-controller.service";
import { RoleControllerService } from "../../../services/role-controller/role-controller.service";
import { ClassificationControllerService } from "../../../services/classifications-controller/classification-controller.service";
import { RoleStatusService } from "../../../services/role-controller/role-status.service";
import { Store } from "../../../services/store.service";
import FormUtils from "../../utils/form-utils.component";
import { BotSelectorComponent } from "../roles/components/bot/bot-selector.component";
import { TranslatedBaseError } from "../TranslatedBaseError";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../../../../environments/environment";
import { TutorialBase } from "../../../models/tutorial-base";
import { DeterminantControllerService } from "../../../services/registration-controller/determinant-controller.service";
import { Institution } from "../../../models/institution";
import { InstitutionControllerService } from "../../../services/institution-controller/institution-controller.service";
import { RoleInstitution } from "../../../models/role-institution";
import { RoleInstitutionControllerService } from "../../../services/role-controller/role-institution-controller.service";
import { MyFormioComponent } from "../../my-formio/my-formio.component";
import { StatusMessageEditComponent } from "./components/status/section/status-message-edit.component";
import { MessageEditComponent } from "./components/status/section/message-edit.component";
import Helpers from "../../../utils/helpers";
import { FormControllerService } from "../../../services/form-controller/form-controller.service";
import { RecoverOrphanConfig } from "../../../models/recover-orphan-config";
import { ServiceControllerService } from "../../../services/service-controller/service-controller.service";

@Component({
  selector: "app-role-detail",
  templateUrl: "./role-detail.component.html",
  providers: [RoleControllerService],
})
export class RoleDetailComponent extends TranslatedBaseError implements OnInit, AfterViewInit {

  public role: Role;
  public serviceId: string;
  public roleId: string;
  public statuses: RoleStatus[];
  public serviceRoles: Role[];
  public registrations: RoleRegistration[];
  public selectedMuleService: MuleService;
  public determinantMapById: { [key: string]: string } = {};
  public institutions: Institution[];
  public roleInstitutions: RoleInstitution[];
  public debugErrors: RecoverOrphanConfig[] = [];

  public isLoading: boolean = false;
  public hideContent: boolean = true;
  public activeTab: string = "general";
  public tabsInitialized: boolean = false;
  public roleInitialized: boolean = false;
  public showFormio: boolean = true;
  public showHistory: boolean = false;
  public showList: boolean = false;
  public messagedata: any = null;
  public rejectionReasons: ClassificationType[] = [];
  @ViewChild('myFormio', { static: false }) myFormio: MyFormioComponent;
  @ViewChild(StatusMessageEditComponent) public statusMessageEditComponent: StatusMessageEditComponent;
  @ViewChild(MessageEditComponent) public messageEditComponent: MessageEditComponent;

  // For edit
  public message: Message;
  public roleStatusMessage: RoleStatusMessage;
  public messageType: string;
  public statusType: string;

  public roleInstitution: any;

  public resizeEdges = { bottom: false, right: false, top: false, left: true };
  public style: object = {};

  public subscriptionMessage: any;
  public subscriptionStatusMessage: any;

  public isFormBuilderOpened = false;
  public isGeneralTabOpened = false;

  public formioOffset = 0;
  public fixButton = false;

  public focusCompKey?: string;
  public baseUrl: string = "";

  @ViewChild(ServiceRoleComponent) public serviceRoleComponent: ServiceRoleComponent;
  @ViewChild(BotSelectorComponent) public BotSelectorComponent: BotSelectorComponent;
  @ViewChild(RolesComponent) public roleComponent: RolesComponent;

  constructor(public roleController: RoleControllerService,
    private roleStatusService: RoleStatusService,
    private muleControllerService: MuleControllerService,
    private institutionControllerService: InstitutionControllerService,
    private determinantService: DeterminantControllerService,
    private classificationControllerService: ClassificationControllerService,
    private roleInstitutionControllerService: RoleInstitutionControllerService,
    public store: Store,
    private route: ActivatedRoute, toastr: ToastrService,
    private formControllerService: FormControllerService,
    private serviceControllerService: ServiceControllerService,
    public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {

    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.baseUrl = "/services/" + this.serviceId + "/roles";
    });
    this.reloadRole();
    this.loadInstitutions();
    this.getServiceRolesList();
    this.getRejectionReasons();
    this.store.state.common.sections.reset();
    this.store.state.common.userLevels.activePage = "ApplicantForm";

    this.subscriptionMessage = this.roleStatusService.initStatusMessageEdit.subscribe((event) => {
      console.log("--- initStatusMessageEdit", event);
      this.roleStatusMessage = event.roleStatusMessage;
      this.message = event.roleStatusMessage.message;
      this.messageType = event.messageType;
      this.statusType = event.statusType;
      this.openStatusMessageEdit();
    });

    this.subscriptionStatusMessage = this.roleStatusService.initMessageEdit.subscribe((event) => {
      console.log("--- initMessageEdit", event);
      this.message = event.message;
      this.messageType = event.messageType;
      this.statusType = event.statusType;
      this.openMessageEdit();
    });

    // fix for leader line
    document.body.classList.add("leader-lines-index-0");
    this.checkDebugMode();
  }

  public checkDebugMode() {
    this.store.debugMode$.subscribe((mode) => {
      if (mode) {
        this.fetchDebugErrors();
      } else {
        this.debugErrors = [];
      }
    });
  }

  private fetchDebugErrors() {
    const cachedResults = this.store.state.common.dryRunResults.get(this.serviceId);
    if (cachedResults) {
      this.debugErrors = cachedResults;
    } else {
      this.serviceControllerService.recoverOrphanConfig(this.serviceId).subscribe((errors) => {
        this.store.state.common.dryRunResults.set(this.serviceId, errors);
        this.debugErrors = errors;
      });
    }
  }

  public saveEditMessage() {
    this.messageEditComponent.submit();
  }

  public saveStatusMessage() {
    this.statusMessageEditComponent.submit();
  }

  public ngOnDestroy() {
    this.subscriptionMessage.unsubscribe();
    this.subscriptionStatusMessage.unsubscribe();
  }

  public ngAfterViewInit() {
    this.scrollToHashIfExists();
  }

  private scrollToHashIfExists() {
    const hash = window.location.hash;
    console.log("-- scrollToHashIfExists", hash);
    if (hash === "#role-main-tab") {
      // Use setTimeout to wait for the DOM to fully render
      setTimeout(() => {
        const element = document.getElementById("role-main-tabs");
        console.log("-- Looking for element with id 'role-main-tabs':", element);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        } else {
          console.log("-- Element 'role-main-tabs' not found");
        }
      }, 500);
    }
  }

  @HostListener("window:scroll", ["$event"])
  public onWindowScroll(event) {
    const mainTabs = document.getElementById("role-main-tabs");
    if (!mainTabs) { return; }
    if (event.target.scrollingElement.scrollTop <= (mainTabs.offsetTop - 40)) {
      document.body.classList.add("leader-lines-index-0");
    } else {
      document.body.classList.remove("leader-lines-index-0");
    }

    this.checkPreviewButtonPosition(event);
  }

  public roleChanged() {
    // recreating formio component here otherwise events pile up
    this.showFormio = true;
    const tab = this.store.state.common.sections.getTab();
    this.scrollToHashIfExists();
    this.notifyTabChange(this.checkTabVisibility(tab), true);
  }

  public setInstitution(e) {
    this.hideLines();
    this.roleInstitution = e;
  }

  public checkTabVisibility(tab) {
    switch (tab) {
      case "form":
        const canShowFormTab = this.role && this.role.type === "UserRole" && this.role.formSchema;
        return canShowFormTab ? tab : "general";
      case "bot-service":
        const canShowMapTab = this.role && this.role.type === "BotRole";
        return canShowMapTab ? tab : "general";
      case "bot-selector":
        const canShowMapTab2 = this.role && this.role.type === "BotRole";
        return canShowMapTab2 ? tab : "general";
      case "statuses":
        return tab;
      default:
        return "general";
    }
  }

  public initTabs() {
    const hasBotRole = this.role && this.role.type === "BotRole";
    if (!this.tabsInitialized && this.BotSelectorComponent && hasBotRole) {
      this.tabsInitialized = true;
      this.notifyTabChange(this.activeTab);
    }
  }

  public notifyTabChange(tab, callDependencies = true) {

    const validTab = this.checkTabVisibility(tab);

    this.activeTab = validTab;
    // save tab on localStorage
    this.store.state.common.sections.setTab(validTab);

    if (callDependencies === true) {
      const hasBotRole = this.role && this.role.type === "BotRole";
      if (hasBotRole && this.BotSelectorComponent) {
        // notify child component
        this.BotSelectorComponent.updateSelector();
      }
    }

    this.getFormioReference();
  }

  public openAddStatusAfterSelect(message) {
    console.log("--- openAddStatusAfterSelect", message);
    this.message = message.message;
    this.messageType = message.type;
    this.statusType = message.statusType;
    this.store.state.common.sections.type = "statusMessageEdit";
  }

  public getRejectionReasons() {
    this.rejectionReasons = [];
    this.classificationControllerService.getClassificationTypesByPage(0, 1000, null, "name", "asc", true).subscribe(
      (data) => {
        this.rejectionReasons = data?.content;
      },
      (error) => {
        console.log("-- Can't get rejections reasons", error);
      });
  }

  public getFormioReference() {
    const reference = document.getElementById("formio-reference");
    if (reference) {
      this.formioOffset = reference.getBoundingClientRect().top;
    }
  }

  public checkPreviewButtonPosition(event) {
    this.getFormioReference();
    this.fixButton = event.target.scrollingElement.scrollTop >= (this.formioOffset + 200);
  }

  public loadInstitutions() {
    this.institutionControllerService.getInstitutions().subscribe(
      (data) => {
        this.institutions = data.sort((a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
        });
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  public reloadRole() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.roleId = params.roleId;
      this.getServiceDeterminantKeyName();
      this.loadRegistrationInstitutions(this.roleId);
      const part = this.roleId.split("#");
      if (part.length > 1) {
        this.roleId = part[0];
        this.focusCompKey = part[1];
      }
      this.showFormio = false;
      this.roleController.getRole(this.roleId).subscribe(
        (data) => this.uploadData(data),
      );

    });
  }

  public loadRegistrationInstitutions(roleId: string) {
    this.roleInstitutionControllerService.getRoleInstitutionList(roleId).subscribe(
      (data) => {
        this.roleInstitutions = data;
      });
  }

  public sortStatusesByNumber(statuses) {
    return statuses.sort((a, b) => {
      const textA = a.sortNumber;
      const textB = b.sortNumber;
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }

  public uploadData(role: Role) {
    this.role = Object.assign(new Role(), role);
    this.role.tutorials = Object.assign(new TutorialBase().tutorials, this.role.tutorials);

    if (!this.role.formSchema) {
      this.role.formSchema = { components: [] };
    }
    this.statuses = this.sortStatusesByNumber(role.statuses);
    this.registrations = this.role.registrations;

    if (this.role.botServiceId !== null && this.role.category === null && this.role.botType === null) {
      this.role.botType = "data";
      this.muleControllerService.getService(this.role.botServiceId).subscribe(
        (data) => {
          this.selectedMuleService = data;
          if (this.selectedMuleService.id.indexOf("read") > -1) { this.role.category = "read"; }
          if (this.selectedMuleService.id.indexOf("list") > -1) { this.role.category = "list"; }
          if (this.selectedMuleService.id.indexOf("search") > -1) { this.role.category = "search"; }
          if (this.selectedMuleService.id.indexOf("create") > -1) { this.role.category = "create"; }
          if (this.selectedMuleService.id.indexOf("update") > -1) { this.role.category = "update"; }
          if (this.selectedMuleService.id.indexOf("exist") > -1) { this.role.category = "exist"; }
          if (!this.role.category) { this.role.category = "create"; }
        },
      );
    }

    if (!this.roleInitialized) {
      this.roleInitialized = true;
      const tab = this.store.state.common.sections.getTab();
      this.notifyTabChange(this.checkTabVisibility(tab), false);
    }
    this.roleChanged();
  }

  public getServiceRolesList() {
    this.roleController.getRolesDetailedList(this.serviceId).subscribe(
      (data) => this.serviceRoles = data,
    );
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public toggleStartRole() {
    this.role.startRole = !this.role.startRole;
    this.roleComponent.isStartRole = true;
    this.updateRole();
  }

  public updateRejectionReason(e) {
    this.role.classificationTypeId = e?.id;
    this.updateRole();
  }

  public saveTutorial(e) {
    if (e) {
      this.role.tutorials.general = e;
      this.saveForm(this.role.formSchema);
    }
  }

  public saveForm(formSchema: any) {
    if (formSchema && formSchema.components) {
      for (const comp of formSchema.components) {
        FormUtils.updateWithVersion(comp);
        FormUtils.updateTableAttributes(comp);
      }
    }
    this.role.formSchema = formSchema;
    this.updateRole();
  }

  public updatedRole(e) {
    if (this.serviceRoleComponent !== undefined) {
      this.serviceRoleComponent.resetMapping();
    } else {
      if (e) {
        this.role = e;
        this.updateRole(true);
      }
    }
  }

  public updateRole(forceInit: boolean = false) {
    const successCb = (data) => {
      this.responseSuccessful("Saved successfully!");
      if (forceInit) {
        this.ngOnInit();
      }
      this.roleComponent.getRolesList();
    };
    const errorCb = (error) => {
      this.ngOnInit();
      return this.showErrorMessageWithTitle("Error during save/update of role!", error);
    };
    if (this.role.type === "BotRole") {
      return this.roleController.saveBotRole(this.role).subscribe(successCb, errorCb);
    } else if (this.role.type === "UserRole") {
      return this.roleController.saveUserRole(this.role).subscribe(successCb, errorCb);
    }
    throw new Error("Undefined role type!");
  }

  public closeEditDeterminant() {
    this.store.state.common.determinantSection.topLayer = null;
    this.store.state.common.determinantSection.determinant = {};
  }

  public closeSection() {
    this.store.state.common.sections.active = false;
    this.store.state.common.sections.type = null;
    this.style = {};
    this.showList = false;
    this.showLines();
  }

  public openStatusMessageEdit() {
    this.store.state.common.sections.active = true;
    this.store.state.common.sections.type = "statusMessageEdit";
  }

  public openMessageEdit() {
    this.store.state.common.sections.active = true;
    this.store.state.common.sections.type = "messageEdit";
  }

  public onResizeEnd(event: ResizeEvent) {
    this.style = {
      width: `${event.rectangle.width}px`,
    };
  }

  public openFormBuilder(openedOrClosed: any) {
    this.isFormBuilderOpened = openedOrClosed;
  }

  public openGeneralTab(openedOrClosed: any) {
    this.isGeneralTabOpened = openedOrClosed;
  }

  public openMessagesList(e) {
    this.messagedata = e;
    this.showList = true;
  }

  public openAddStatus() {
    this.store.state.common.sections.active = true;
    this.store.state.common.sections.type = "status";
  }

  public changeBotType() {
    this.BotSelectorComponent.listeningTypeChanged(this.role.botType);
  }

  public changeBotCategory() {
    this.BotSelectorComponent.listeningCategoryChanged(this.role.category);
  }

  public changeBotSelectorType(type) {
    this.role.botType = type;
  }

  public changeBotSelectorCategory(category) {
    this.role.category = category;
  }

  public openHistory() {
    this.showHistory = true;
  }

  public closeHistory() {
    this.showHistory = false;
  }

  public changeForm(revisionNumber: string): void {
    if (revisionNumber) {
      // Step 1: GET the schema for validation
      this.roleController.getFormSchemaForRevision(this.role.id, revisionNumber).subscribe((schema) => {
        if (schema) {
          // Step 2: Validate schema for duplicate keys
          const result = Helpers.validateFormSchema(schema);
          if (Array.isArray(result) && result.length > 0) {
            this.error("Please reload page!\n" + Helpers.generateValidationErrorMessages(result).join("\n"), 'Validation error');
          }
          else {
            // Step 3: If valid, call PUT to revert (triggers cleanup of orphaned relations)
            this.roleController.revertFormToRevision(this.role.id, revisionNumber).subscribe(
              () => {
                // Step 4: Reload the role after successful reversion
                this.roleController.getRole(this.role.id).subscribe(
                  (data) => {
                    this.role = data ? data : this.role;
                    this.responseSuccessful("Form reverted successfully");
                  },
                  (error) => this.showErrorMessage(error)
                );
              },
              (error) => this.showErrorMessage(error)
            );
          }
        }
      });
    }
  }
  public isForApplicant() {
    if (this.role) {
      return this.role.assignedTo === "applicant" || this.role.assignedTo === "applicantPayment";
    }
    return false;
  }

  public toggleAccessReport() {
    this.role.allowAccessToFinancialReports = !this.role.allowAccessToFinancialReports;
    this.updateRole();
  }

  public toggleAllowToConfirmPayments() {
    this.role.allowToConfirmPayments = !this.role.allowToConfirmPayments;
    this.updateRole();
  }

  public updateDeterminant(e) {
    this.role = e;
    this.ngOnInit();
  }

  public hideLines(): void {
    document.querySelectorAll(".flow-line").forEach((l) => {
      l.classList.add("overlap");
    });
  }

  public showLines(): void {
    document.querySelectorAll(".flow-line").forEach((l) => {
      l.classList.remove("overlap");
    });
  }

  public downloadSchema() {
    if (this.role && this.role.formSchema && this.role.formSchema._id) {
      this.formControllerService.downloadSchemaWithRelations(this.role.formSchema._id).subscribe(
        (data) => {
          const blob = new Blob([data], { type: "application/octet-stream" });
          const downloadURL = window.URL.createObjectURL(data);
          const link = document.createElement("a");
          link.href = downloadURL;
          link.download = `${this.store.state.common.serviceName}_role_form_schema.json`;
          link.click();
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }
}
